import * as React from 'react';
import { useState, useEffect } from 'react';
import axios from 'axios';
import Papa from 'papaparse';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import "./PublicPots.css";


function PublicPots () {

  const tournamentCut = 0.92;

  const [alignment, setAlignment] = useState('boat');
  const [boatList, setBoatList] = useState([]);
  const [potData, setPotData] = useState();
  const [boatName, setBoatName] = useState();
  const [category, setCategory] = useState();
  const [categoryList, setCategoryList] = useState([]);
  const [boatsEnteredList, setBoatsEnteredList] = useState([]);
  const [totalPotAmount, setTotalPotAmount] = useState();
  const [totalCategoryAmount, setTotalCategoryAmount] = useState();
  const [potsEnteredList, setPotsEnteredList] = useState([]);

  const handleTabChange = (event, newAlignment) => {
    setAlignment(newAlignment);
  };

  const sumPots = (obj) => {
    const values = Object.values(obj);
    const sum = values.slice(1, values.length).reduce((accumulator, value) => {
      return +accumulator + +value;
    }, 0);
    console.log(sum);
    console.log(values);
    return sum.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");;
  }

  const handleBoatSelection = (e) => {
    
    setBoatName(e.target.value);

    let pot = potData[e.target.value]
    let potSum = sumPots(pot);
    setTotalPotAmount(potSum);
    Object.entries(pot).forEach(([k, v]) => {
      if (v === "0") delete pot[k];
    });

    let realPots = Object.keys(pot);
    setPotsEnteredList(realPots.slice(1, realPots.length))
  }

  const handleCategorySelection = (e) => {
    let categoryName = e.target.value;
    setCategory(categoryName);

    let moneyList = []
    let nameList = []
    boatList.forEach((boat, i) => {
      if (potData[boat][categoryName] !== "0") {
        nameList.push(boat);
        moneyList.push(potData[boat][categoryName]);
      } 
    })

    let sum = moneyList.reduce((accumulator, value) => {
      return +accumulator + +value;
    }, 0);
    sum = sum * tournamentCut;
    setTotalCategoryAmount(sum.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
    setBoatsEnteredList(nameList);
  }

  useEffect(() => {

    async function fetchCsv() {
      const response = await fetch('/data/pots.csv');
      const reader = response.body.getReader();
      const result = await reader.read();
      const decoder = new TextDecoder('utf-8');
      const csv = await decoder.decode(result.value);
      return csv;
    }

    async function getData() {

      // Get data
      const data = Papa.parse(await fetchCsv());
      const headers = data["data"][0];
      const content = data["data"].slice(1, data["data"].length);
  
      // Parse
      const potObject = {}
      content.forEach((boat, i) => {
        let tempObject = {}
        headers.forEach((column, j) => {
          tempObject[column] = boat[j];
        })
        potObject[boat[0]] = tempObject;
      })

      // Extract variables
      let boats = await Object.keys(potObject);
      setBoatList(boats);
      setCategoryList(headers.slice(1, headers.length));
      setPotData(potObject);
    }

    getData();

  }, []);

  return (
    <>
      <ToggleButtonGroup
        color="primary"
        value={alignment}
        exclusive
        onChange={handleTabChange}
        aria-label="Platform"
      >
        <ToggleButton value="boat">Fish Pots by Boat</ToggleButton>
        <ToggleButton value="pot">Fish Pots by Category</ToggleButton>
      </ToggleButtonGroup>
      { alignment == "boat" ? (
        <>
          <h2>Fish Pots by Boat</h2>
          { boatList.length > 0 ? (
            <>
              <label className="fishPotLabel">Boat: </label>
              <select onChange={handleBoatSelection}>
                <option value="" disabled selected hidden></option>
                {boatList.map((boat, i) => {
                  return <option key={i} value={boat} >{boat}</option>
                })}
              </select>
            </>
          ) : (
            <></>
          )}
          <br/>
          <br/>
          <label className="fishPotLabel">Total Amount In Pots: ${totalPotAmount}</label>
          <br/>
          <br/>
          <label className="fishPotLabel">List of Pots Entered: </label>
          { potsEnteredList.length > 0 ? (
            <>
              {potsEnteredList.map((pot, i) => {
                return <p>{pot}</p>
                })
              }
            </>
          ) : (
            <></>
          )}
          <br/>
          <br/>
          <br/>
        </>
      ) : (
        <>
          <h2>Fish Pots by Category</h2>
          { categoryList.length > 0 ? (
            <>
              <label className="fishPotLabel">Category: </label>
              <select onChange={handleCategorySelection}>
                <option value="" disabled selected hidden></option>
                {categoryList.map((category, i) => {
                  return <option key={i} value={category} >{category}</option>
                })}
              </select>
            </>
          ) : (
            <></>
          )}
          <br/>
          <br/>
          <label className="fishPotLabel">Total Amount In Category Pot: ${totalCategoryAmount}</label>
          <br/>
          <br/>
          <label className="fishPotLabel">{boatsEnteredList.length} Boats are in this Pot: </label>
          { boatsEnteredList.length > 0 ? (
            <>
              {boatsEnteredList.map((boat, i) => {
                return <p>{boat}</p>
                })
              }
            </>
          ) : (
            <></>
          )}
          <br/>
          <br/>
          <br/>
        </>
      )}
    </>
  );
}

export default PublicPots;

